// Convert a phone string (possibly containing vanity letters like KNOCK) into
// digits-only suitable for tel: hrefs. Maps A-Z to T9 keypad digits (2-9).
export const toTelDigits = (phone) => {
  if (!phone) return "";
  return phone
    .toUpperCase()
    .split("")
    .map((ch) => {
      if (ch >= "0" && ch <= "9") return ch;
      if (ch >= "A" && ch <= "Z") {
        const code = ch.charCodeAt(0) - 65;
        // A-C=2, D-F=3, G-I=4, J-L=5, M-O=6, P-S=7, T-V=8, W-Z=9
        if (code <= 2) return "2";
        if (code <= 5) return "3";
        if (code <= 8) return "4";
        if (code <= 11) return "5";
        if (code <= 14) return "6";
        if (code <= 18) return "7";
        if (code <= 21) return "8";
        return "9";
      }
      return "";
    })
    .join("");
};
